import React from 'react';
import { FormattedMessage } from 'react-intl';
import { addNotification } from 'reapop';
import { get } from 'lodash';
import moment from 'moment';
import {
  APPROVAL_REQUEST_CREATE,
  APPROVAL_REQUEST_SUCCESS,
  APPROVAL_REQUEST_FAILURE,
} from '../constants/ActionTypes';
import { custom } from '../utils/Api';

export const approvalRequestCreate = () => ({
  type: APPROVAL_REQUEST_CREATE,
});

export const approvalRequestSuccess = () => ({
  type: APPROVAL_REQUEST_SUCCESS,
});

export const approvalRequestFailure = () => ({
  type: APPROVAL_REQUEST_FAILURE,
});

export const createApprovalRequest = (data, cb) => async (dispatch, getState) => {
  const payload = data;
  try {
    dispatch(approvalRequestCreate());
    const {
      loginReducer: {
        user: { DefaultEmployeeDetailID },
      },
    } = getState();
    const { ConnectedID } = payload;
    delete payload.ConnectedID;
    const requestConfig = {
      url: '/kjarni/api/v2/EmployeeDetailApprovalRequests',
      method: 'POST',
      data: {
        ...payload,
        ...ConnectedID && { ConnectedID },
        EmployeeDetailID: DefaultEmployeeDetailID,
        ExpirationDate: moment(get(payload, 'PeriodBegda', new Date())).toISOString(),
        PeriodBegda: moment(get(payload, 'PeriodBegda', new Date())).toISOString(),
        PeriodEndda: moment(get(payload, 'PeriodEndda', new Date())).toISOString(),
      },
    };

    await custom(requestConfig);
    dispatch(approvalRequestSuccess());
    // Notificaiton on success
    dispatch(addNotification({
      title: <FormattedMessage id="approvalRequest.create.success" />,
      status: 'success',
      dismissible: true,
      dismissAfter: 5000,
    }));
    cb();
  } catch (error) {
    // Notification on error
    const errorData = get(error, 'response.data');
    const errorMessageJsonString = get(errorData, 'error.message');
    let missingEmailError = false;
    try {
      const parsedError = JSON.parse(errorMessageJsonString);
      if (get(parsedError, 'Errors[0].UserMessage') === 'Error_EmailWorkMissing') {
        missingEmailError = true;
      }
    } catch (parseError) {
      console.log('Error parsing error message json string', parseError);
    }
    dispatch(addNotification({
      title: <FormattedMessage id="approvalRequest.create.error" />,
      message: missingEmailError ? <FormattedMessage id="approvalRequest.create.error.missingEmail" /> : get(error, 'message'),
      status: 'error',
      dismissible: true,
      dismissAfter: 12000,
    }));
    dispatch(approvalRequestFailure());
  }
};



// WEBPACK FOOTER //
// ./src/actions/ApprovalRequests.js